import type { ReactElement } from 'react'
import { useCallback, useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import ModalContext from 'contexts/ModalContext'
import LandingPageLoyaltyTourExpCreditBenefitsModal from './LandingPageLoyaltyTourExpCreditBenefitsModal'

interface Props {
  layout: 'tile' | 'row'
  benefit: App.LoyaltyBenefit
  benefitLabel: ReactElement
}

function LandingPageLoyaltyTourExpCredit(props: Props) {
  const { layout, benefit, benefitLabel } = props
  const showModal = useContext(ModalContext)
  const intl = useIntl()
  const image = useMemo<App.Image>(() => ({
    id: '69vg83q7obl8xw4x1ac',
    title: intl.formatMessage({
      id: 'zYsMb0vsp3sU6PvDflwe',
      defaultMessage: 'Extras on your tour',
      description: 'Alternative text fallback for the tour extras loyalty benefit image',
    }),
  }), [intl])

  const handleDetailsClick = useCallback(() => {
    showModal(<LandingPageLoyaltyTourExpCreditBenefitsModal
      image={image}
      benefitValue={benefit.value?.amount ?? 0}
    />)
  }, [benefit, image, showModal])

  return <LandingPageLoyaltyBenefitTile
    layout={layout}
    benefitType="tour_exp_credit"
    heading={intl.formatMessage({
      defaultMessage: 'Tour optional extra credits',
      id: 'j5urduxHC-A_ol5qd0LZ',
      description: 'Heading for loyalty tour experience credit benefit tile',
    })}
    subtitle={benefitLabel}
    onClick={handleDetailsClick}
  />
}

export default LandingPageLoyaltyTourExpCredit
